import T from "components/T";
import React from "react";
import {useDispatch} from "react-redux";
import NavBarItem from "./NavBarItem";

const NavBarLeft = () => {
    return (
        <div className="NavBarLeft w-16 fixed left-0 top-16 right-auto bg-white bottom-0 z-50 flex pt-8 pb-8 flex-col justify-start items-stretch">
            <ul className="w-full list-none pl-0 border-b border-gray-200" role="list">
                <NavBarItem img={"/img/map.svg"} text={<T>Dashboard</T>} to={"/admin/map"} />
                <NavBarItem img={"/img/people.svg"} text={<T>Live Queue</T>} to={"/admin/queue"} />
                <NavBarItem img={"/img/performance.svg"} text={<T>Performance</T>} to={"/admin/details/1"} />
                <NavBarItem img={"/img/charts.svg"} text={<T>Statistics</T>} to={"/admin/stats/1"} />
            </ul>
        </div>
    );
};
export default NavBarLeft;
